import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BASE_URL_IMAGE } from '../../../helper/helper';
import { logout } from "../../../redux/reducers/userReducer";

const TopBar = () => {
  const { userData } = useSelector((store) => store.userReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ── User info ──────────────────────────────────────────
  const adminName = "Admin";
  const adminRole = "Administrator";

  const rawProfile =
    userData?.profileImage ||
    userData?.profile_picture ||
    userData?.profile_pic ||
    userData?.photo ||
    userData?.image ||
    userData?.avatar ||
    "";

  const profileImage = "/assets/images/profile.jpg";

  const handleLogout = () => {
    dispatch(logout());
    navigate("/admin-login");
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700&family=DM+Sans:wght@400;500&display=swap');

        .tb-bar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          background: #fff;
          border-radius: 16px;
          padding: 12px 20px;
          margin-bottom: 24px;
          border: 1px solid #f1f5f9;
          box-shadow: 0 2px 12px rgba(99,102,241,0.06);
        }

        /* ── Search ── */
        .tb-search {
          display: flex;
          align-items: center;
          gap: 10px;
          background: #f8faff;
          border: 1.5px solid #e2e8f0;
          border-radius: 10px;
          padding: 9px 16px;
          flex: 1;
          max-width: 380px;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .tb-search:focus-within {
          border-color: #6366f1;
          box-shadow: 0 0 0 3px rgba(99,102,241,0.08);
        }
        .tb-search i {
          color: #94a3b8;
          font-size: 14px;
          flex-shrink: 0;
        }
        .tb-search input {
          border: none;
          outline: none;
          background: transparent;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          color: #334155;
          width: 100%;
        }
        .tb-search input::placeholder { color: #cbd5e1; }

        /* ── Right side ── */
        .tb-right {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        /* Icon buttons */
        .tb-icon-btn {
          width: 38px; height: 38px;
          border-radius: 10px;
          border: 1.5px solid #f1f5f9;
          background: #f8faff;
          color: #64748b;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer;
          transition: background 0.18s, border-color 0.18s, color 0.18s;
          position: relative;
          font-size: 15px;
        }
        .tb-icon-btn:hover {
          background: #ede9fe;
          border-color: #c4b5fd;
          color: #6366f1;
        }

        /* Notification dot */
        .tb-notif-dot {
          position: absolute;
          top: 7px; right: 7px;
          width: 7px; height: 7px;
          border-radius: 50%;
          background: #ef4444;
          border: 1.5px solid #fff;
        }

        /* Divider */
        .tb-divider {
          width: 1px;
          height: 28px;
          background: #f1f5f9;
          margin: 0 4px;
        }

        /* Profile section */
        .tb-profile {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 6px 10px 6px 6px;
          border-radius: 12px;
          border: 1.5px solid #f1f5f9;
          cursor: pointer;
          transition: background 0.18s, border-color 0.18s;
        }
        .tb-profile:hover {
          background: #f8faff;
          border-color: #c4b5fd;
        }
        .tb-avatar {
          width: 34px; height: 34px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #ede9fe;
          flex-shrink: 0;
        }
        .tb-profile-info { line-height: 1.2; }
        .tb-profile-name {
          font-family: 'Syne', sans-serif;
          font-size: 13px;
          font-weight: 700;
          color: #1e1b4b;
        }
        .tb-profile-role {
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          color: #94a3b8;
        }
        .tb-profile-chevron {
          color: #cbd5e1;
          font-size: 11px;
          margin-left: 2px;
        }

        /* Logout */
        .tb-logout-btn {
          width: 38px; height: 38px;
          border-radius: 10px;
          border: 1.5px solid #fee2e2;
          background: #fff1f2;
          color: #ef4444;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer;
          transition: background 0.18s, border-color 0.18s;
          font-size: 15px;
        }
        .tb-logout-btn:hover {
          background: #fee2e2;
          border-color: #fca5a5;
        }
      `}</style>

      <div className="tb-bar">

        {/* Search */}
        <div className="tb-search">
          <i className="fas fa-search" />
          <input type="text" placeholder="Search anything..." />
        </div>

        {/* Right */}
        <div className="tb-right">

        

          <div className="tb-divider" />

          {/* Profile */}
          <div
            className="tb-profile"
            
          >
            <img src={profileImage} alt="Profile" className="tb-avatar" />
            <div className="tb-profile-info">
              <div className="tb-profile-name">{adminName}</div>
              <div className="tb-profile-role">{adminRole}</div>
            </div>
            <i className="fas fa-chevron-down tb-profile-chevron" />
          </div>

          {/* Logout */}
          <button className="tb-logout-btn" onClick={handleLogout} title="Logout">
            <i className="fas fa-sign-out-alt" />
          </button>

        </div>
      </div>
    </>
  );
};

export default TopBar;